// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RMkO","title":"styles_title__1_boq"};